import ExternalComprobanteListStore from './receptores/comprobantes/state/ExternalComprobanteListStore';
import ExternalComprobanteInfoStore from './receptores/comprobantes/state/ExternalComprobanteInfoStore';
import ExternalAutofacturacionTicketListStore from './receptores/autofacturacion/state/ExternalAutofacturacionTicketListStore';

const ExternalStore = {
  receptores: {
    comprobantes: {
      info: ExternalComprobanteInfoStore,
      list: ExternalComprobanteListStore,
    },
    autofacturacion: {
      list: ExternalAutofacturacionTicketListStore,
    },
  },
};

export default ExternalStore;
